import React, {useEffect, useRef, useState} from 'react'

import { connect } from 'react-redux'
import RequireAuth from "../../../../../root/Routes/RequiredAuth";
import Profile from "pages/Settings/components/RightSide/Profile";
import ChangePassword from "pages/Settings/components/RightSide/ChangePassword";
import {Route, Switch} from "react-router-dom";



const Routers=[
    {
        component: RequireAuth(Profile),
        exact: true,
        path: '/settings',
    },
    {
        component: RequireAuth(ChangePassword),
        exact: true,
        path: '/settings/change_password',
    },
]

const RightSide: React.FC<any> = ({ leftMenuStatus }) => {


    return (
        <>

            <Switch>
                {
                    Routers.map((route) => (
                        <Route {...route} key={route.path} />
                    ))

                }
            </Switch>
        </>
    )
}
const mapStateToProps = (state: any) => ({
    leftMenuStatus: state.home.leftMenuStatus,
})
export default connect(mapStateToProps, null)(RightSide)
